module.exports = __webpack_public_path__ + "static/media/dice-6.4be2a648.svg";